import React, { CSSProperties } from 'react';
import * as Styles from './Button.styles';

type Props = {
	accent: string;
	color: string;
	disabled?: boolean;
	label: string;
	onClick: (e: React.MouseEvent<HTMLDivElement, any>) => void;
	variant: 'solid' | 'transparent';
	style?: CSSProperties;
};

export const Button = (props: Props) => {
	return (
		<Styles.Wrapper
			accent={props.accent}
			color={props.color}
			disabled={props.disabled}
			onClick={props.disabled ? undefined : props.onClick}
			transparent={props.variant === 'transparent'}
			style={props.style}
		>
			<p>{props.label}</p>
		</Styles.Wrapper>
	);
};
